<template>
  <tbody>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <span
          v-if="!$_updateActionAllowed"
          class="lock"
          :title="'Obrázek nelze editovat.' | translate"
          v-translate>
			</span>
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Obrázek' | translate" class="image">
      <img :src="entity.path">
    </td>
    <td :data-th="'Typ' | translate">
      {{ getTypeText(entity.type) }}
    </td>
    <td v-if="$_loggedUser_selectedOperatorId" :data-th="'Globální' | translate">
      <img
          class="is_set"
          src="../../../assets/images/is-set.svg"
          :alt="'Ano' | translate"
          v-if="!entity.id_operator">
    </td>
    <td v-else :data-th="'Operátor' | translate">
      {{ entity.operator_name}}
    </td>
    <td :data-th="'Vytvořeno' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteImage">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
  </tbody>
</template>

<script>
import rowActions from "../../mixins/row-actions";
import images from "./mixins/images";

export default {
  name: "ImagesRow",
  mixins: [rowActions, images],
  props: {
    entity: Object,
  },
  data(){
    return{
      detailPageRouteName: "imagesDetail",
    }
  },
  methods: {
    emitDeleteImage() {
      this.$emit('deleteImage', String(this.entity.id))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/images/ImagesRow.vue